<template>
  <div class="donation">
    <label class="inputWrapper">
      <v-text-field
        v-model="inputValue"
        class="input"
        outlined
        dense
        clearable
        type="number"
        step="1000"
        color="#FFA903"
        flat
        style="border-radius: 0 !important;"
        required
        placeholder="1000"
        @input="onInputChangeHandler"
      />
      <v-checkbox
        class="checkbox"
        color="#FFA903"
        off-icon="mdi-checkbox-blank"
        v-model="isChecked"
        @change="onCheckedChangeHandler"
        :label="bookData.lsaranHelpDescription"
      >
      </v-checkbox>
    </label>
  </div>
</template>

<script>
export default {
  name: "DonationField",
  props: ["checked", "input"],
  computed: {
    bookData() {
      return this.$t("book");
    }
  },
  data() {
    return {
      inputValue: this.input,
      isChecked: this.checked
    };
  },
  methods: {
    onCheckedChangeHandler(value) {
      this.$emit("onCheckboxChange", value);
    },
    onInputChangeHandler(value) {
      this.$emit("onInputChange", value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/vars";

.donation {
  width: 100%;
  padding: 28px 20px 12px;
  background: #f3f9fc;
  border: 1px solid $textBlack;
}

.inputWrapper {
  display: flex;
  flex-direction: column;
}

.checkbox {
  margin-top: -8px;
}
</style>
